import { render, staticRenderFns } from "./TopWallets.vue?vue&type=template&id=1770da9a&"
import script from "./TopWallets.vue?vue&type=script&lang=ts&"
export * from "./TopWallets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports